import { lazy } from "react";

const routes = [
  {
    path: "/subModuleOrgMapping",
    element: lazy(
      () => import("../../pages/ModulePersonalization/SubModuleOrgMapping"),
    ),
  },
  {
    path: "/subModuleOrgMapping/create",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/SubModuleOrgMapping/create-editSubModuleOrgMapping"),
    ),
  },
  {
    path: "/subModuleOrgMapping/edit/:id",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/SubModuleOrgMapping/create-editSubModuleOrgMapping"),
    ),
  },
];

export default routes;
